import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/lac-logo-white.svg'


const _hoisted_1 = { class: "main-footer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "footer-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "lac-logo-white",
    src: _imports_0,
    alt: "lac-icon"
  })
], -1)
const _hoisted_3 = { class: "footer-links" }
const _hoisted_4 = { class: "medium-text-white footer-text" }
const _hoisted_5 = { class: "medium-text-white footer-text" }
const _hoisted_6 = { class: "medium-text-white footer-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("component-main-footer.contacts-footer")), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("component-main-footer.privacy-footer")), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("component-main-footer.terms-footer")), 1)
    ])
  ]))
}